import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  constructor(private loggerService: LoggerService) {
    super();
  }

  public handleError(error: Error) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    this.loggerService.logException(error);
    console.error(error);

    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }
  }
}
